import React from 'react';
import { Container, Table } from 'react-bootstrap';
import { isUndefined, isNull } from 'lodash';

import { BackButton, CopyLinkButton } from '@components/Base';
import { BenefitGroupTypes } from '@models/PersonalAccidentPlanBenefitGroup';
import HeaderSecondary from '@components/HeaderSecondary';
import { Loading, LoadingError } from '@components/Base';

import { usePersonalAccidentQuotesFetch } from './hook';
import { TableInsurer } from './table-insurer';
import { TableAnnualLimit } from './table-annual-limit';
import { TableGeographicCoverage } from './table-geographic-coverage';
import { TableBenefit } from './table-benefit';

const PersonalAccidentQuoteComparePage = () => {
  const personalAccidentQuotes = usePersonalAccidentQuotesFetch();

  if (isUndefined(personalAccidentQuotes)) return <Loading />;
  if (isNull(personalAccidentQuotes)) return <LoadingError />;

  return (
    <>
      <HeaderSecondary />
      <Container className="mt-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <BackButton />
          <CopyLinkButton />
        </div>

        <Table>
          <tbody>
            <TableInsurer />
            <TableAnnualLimit />
            <TableGeographicCoverage />
            <TableBenefit groupType={BenefitGroupTypes.BasicBenefits} />
            <TableBenefit groupType={BenefitGroupTypes.Extensions} />
            <TableBenefit groupType={BenefitGroupTypes.Iema} />
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export { PersonalAccidentQuoteComparePage };
